import React, { useEffect, useRef } from 'react'
import { Card, Col, Form, Row } from 'react-bootstrap'
import Autocomplete from '../../custom/autocomplete'
import DatepickerCustom from '../../datepicker-custom'
import LabelCustom from '../../label-custom'
import { Controller } from 'react-hook-form'
import UseEmpsTypes from '../../../hooks/use-emps-types'
import UseEmpsTitle from '../../../hooks/use-emps-titles'
import { useState } from 'react'
import UsePayments from '../../../hooks/use-payments'
import UseBanks from '../../../hooks/use-emps-banks'
import UseEmpsShifts from '../../../hooks/use-emps-shifts'
import UseEmpsProbations from '../../../hooks/use-emps-probations'
import UseEmpsReportby from '../../../hooks/use-emps-reportby'
import UseTeams from '../../../hooks/use-teams'
import UsePositions from '../../../hooks/use-position'
import { useSelector } from 'react-redux'
import moment from 'moment'
import {
  getEmployeeChecksPaymentGroupAPI,
  getEmpsChkCodeAPI,
  getEmpsChkUsernameAPI
} from '../../../services/employee'
import { useDebounce } from '@react-hook/debounce'
import InputNumber from '../../input-number'
import UseGroups from '../../../hooks/use-groups'
import UseFactionAll from '../../../hooks/use-factions-all'
import UseDepartmentsAll from '../../../hooks/use-departmentsAll'
import useNumberInput from '../../../helper/input-fix-num'
import useEngNumInput from '../../../helper/input-fix-en-num'
import UseEmpsSupervisor from '../../../hooks/use-emps-supervisor'
import UseDropPaymentGroups from '../../../hooks/use-drop-payment-groups'
import { usIsPassProbationStore } from '../../../store/pim'
import UseEmpsAirport from '../../../hooks/use-emps-airport'
import UseEmpsProject from '../../../hooks/use-emps-project'
import { useOrgSeleteStore } from '../../../store/layout'
import UseOrgLevelId from '../../../hooks/useOrgLevelId'

function Infomation({ control, setValue, data, errors, setError }) {
  const { orgSelete } = useOrgSeleteStore()

  const orgId = useSelector((state) => state.roleReducer.role)
  const [keyReportTo, setKeyReportTo] = useDebounce('', 1000)
  const [keySupervisor, setKeySupervisor] = useDebounce('', 1000)
  const { isPassProbation, setIsPassProbation } = usIsPassProbationStore()

  const empsTypes = UseEmpsTypes()
  const empsTitle = UseEmpsTitle()
  const payments = UsePayments()
  const banks = UseBanks()
  const shifts = UseEmpsShifts()
  const orgLevelIdOption = UseOrgLevelId()
  const empProbations = UseEmpsProbations()
  const paymentGroups = UseDropPaymentGroups()
  const reportby = UseEmpsReportby(orgId, keyReportTo)
  const supervisor = UseEmpsSupervisor(orgId, keySupervisor)

  const airports = UseEmpsAirport()
  const projects = UseEmpsProject(orgId)
  const [divisionId, setDivisionId] = useState(0)
  const [factionId, setFactionId] = useState(0)
  const [departmentId, setDepartmentId] = useState(0)
  const [teamId, setTeamId] = useState(0)

  const divisions = UseGroups(orgId) //สายงาน
  const factions = UseFactionAll(orgId, divisionId)
  const department = UseDepartmentsAll(orgId, divisionId, factionId) //แผนก
  const teams = UseTeams(orgId, divisionId, departmentId) //ทีม
  const positions = UsePositions(orgId, divisionId, departmentId, teamId) //ตำแน่ง

  const [empsTitleTH, setEmpsTitleTH] = useState([])
  const [empsTitleEng, setEmpsTitleEng] = useState([])
  const inputRef = useRef(null)
  const handleKeyDownNum = useNumberInput(inputRef)
  const handleKeyDownENnum = useEngNumInput(inputRef)

  useEffect(() => {
    if (empsTitle.length > 0) {
      const newDataTH = empsTitle.map((d, i) => {
        return { value: d.id, label: d.th, id: d.id, sex: d.sex }
      })

      const newDataENG = empsTitle.map((d, i) => {
        return { value: d.id, label: d.en, id: d.id, sex: d.sex }
      })

      const titleTHNew = newDataTH.find((d) => d.label === data?.title_th)
      setValue('title_th', titleTHNew)
      const titleENNew = newDataENG.find((d) => d.label === data?.title_en)
      setValue('title_en', titleENNew)

      setEmpsTitleTH(newDataTH)
      setEmpsTitleEng(newDataENG)
    }
  }, [empsTitle, data, setValue])

  const [keyCode, setKeyCode] = useDebounce('', 1000)
  const [isCode, setIsCode] = useState(true)
  const [keyUsername, setKeyUsername] = useDebounce('', 1000)
  const [isUsername, setIsUsername] = useState(true)
  useEffect(() => {
    if (keyCode) {
      const getEmpsChkCode = async () => {
        const data = await getEmpsChkCodeAPI({ orgId, searchs: keyCode })
        if (!data) return
        if (data.status) {
          setValue('checkCode', data.result.status)
          setError('checkCode', data.result.status)

          // setError('code', !data.result.status)

          setIsCode(data.result.status)
        }
      }
      getEmpsChkCode()
    }
    return () => {}
  }, [keyCode, orgId, setError, setValue])

  useEffect(() => {
    if (keyUsername) {
      const getEmpsChkUsername = async () => {
        const data = await getEmpsChkUsernameAPI({
          orgId,
          searchs: keyUsername
        })
        if (!data) return
        if (data.status) {
          setValue('checkUsername', data.result.status)
          setError('checkUsername', data.result.status)

          setError('username', !data.result.status)
          setIsUsername(data.result.status)
        }
      }
      getEmpsChkUsername()
    }
    return () => {}
  }, [keyUsername, orgId, setError, setValue])

  const [bdCheckPayment, setBdCheckPayment] = useState()
  const getEmpChecksPaymentGroup = async (body) => {
    try {
      const resp = await getEmployeeChecksPaymentGroupAPI(body)
      if (!resp) return
      if (resp.status) {
        setValue('paymentGroup', {
          value: resp.result.paymentGroupId,
          label: resp.result.paymentGroupName
        })
      } else {
        setValue('paymentGroup', null)
      }
    } catch (error) {}
  }
  // console.log("error",error);

  return (
    <>
      <Card border="0">
        <Card.Body>
          <h5 className="mb-3 fw-bold">ข้อมูลทั่วไป</h5>
          <Row style={{ rowGap: '15px' }}>
            <Col xl={3} md={6} hidden={orgSelete?.isCodeAuto}>
              <LabelCustom text={'รหัสพนักงาน'} />
              <Controller
                name={'code'}
                control={control}
                render={({ field: { value = ``, onChange } }) => (
                  <InputNumber
                    className={`${
                      !isCode && keyCode ? 'text-danger border-danger' : ''
                    }`}
                    maxLength={10}
                    value={value}
                    onChange={(d) => {
                      onChange(d)
                      setValue('code', d.target.value)
                      setKeyCode(d.target.value)
                    }}
                  />
                )}
              />

              {!isCode && keyCode && (
                <label className="small text-danger">
                  รหัสพนักงานนี้มีในระบบแล้ว
                </label>
              )}

              {errors.code?.message && (
                <label className="small text-danger">
                  {errors.code.message}
                </label>
              )}
            </Col>
            <Col xl={3} md={6}>
              <LabelCustom text="Username" subtext={'(ถ้ามี)'} />
              <Controller
                name={'username'}
                control={control}
                render={({ field: { value = '' } }) => (
                  <Form.Control
                    value={value}
                    className={`${
                      !isUsername && keyUsername
                        ? 'text-danger border-danger'
                        : ''
                    }`}
                    onChange={(d) => {
                      setValue('username', d.target.value)
                      setKeyUsername(d.target.value)
                    }}
                    onKeyDown={handleKeyDownENnum}
                  />
                )}
              />

              {!isUsername && keyUsername && (
                <label className="small text-danger">
                  ชื่อผู้ใช้นี้มีในระบบแล้ว
                </label>
              )}
            </Col>
            <Col xl={3} md={6}>
              <LabelCustom text="สถานะทดลองงาน" />
              <Controller
                name={'empProbations'}
                control={control}
                render={({ field: { onChange, value = '' } }) => (
                  <Autocomplete
                    options={empProbations}
                    value={value}
                    onChange={(e) => {
                      onChange(e)
                      setIsPassProbation(e.value === 3)
                    }}
                  />
                )}
              />
              {errors.empProbations && (
                <label className="small text-danger">
                  {errors.empProbations.message}
                </label>
              )}
            </Col>
            <Col xl={3} md={6}>
              <LabelCustom text="ประเภทพนักงาน" />
              <Controller
                name={'empsTypes'}
                control={control}
                render={({ field: { onChange, value = '' } }) => (
                  <Autocomplete
                    options={empsTypes}
                    value={value}
                    onChange={(e) => {
                      setBdCheckPayment({
                        ...bdCheckPayment,
                        typeId: e.value
                      })
                      getEmpChecksPaymentGroup({
                        ...bdCheckPayment,
                        typeId: e.value
                      })
                      onChange(e)
                    }}
                  />
                )}
              />
              {errors.empsTypes && (
                <label className="small text-danger">
                  {errors.empsTypes.message}
                </label>
              )}
            </Col>

            <Col xl={3} md={4}>
              <LabelCustom text="วันที่เริ่มงาน" />
              <Controller
                name={'startDate'}
                control={control}
                render={({ field: { value = '', onChange } }) => (
                  <DatepickerCustom
                    value={value}
                    onChange={([date]) => {
                      onChange(
                        `${date ? moment(date).format('YYYY-MM-DD') : ''}`
                      )
                    }}
                  />
                )}
              />
              {errors.startDate?.message && (
                <label className="small text-danger">
                  {errors.startDate.message}
                </label>
              )}
            </Col>
            <Col xl={3} md={4}>
              <LabelCustom
                text="วันที่บรรจุ"
                subtext={!isPassProbation && '(ถ้ามี)'}
              />
              <Controller
                name={'employDate'}
                control={control}
                render={({ field: { value = '', onChange } }) => (
                  <DatepickerCustom
                    value={value}
                    onChange={([date]) => {
                      let _date = date ? moment(date).format('YYYY-MM-DD') : ''
                      onChange(_date)
                    }}
                  />
                )}
              />
              {errors.employDate?.message && isPassProbation && (
                <label className="small text-danger">
                  {errors.employDate.message}
                </label>
              )}
            </Col>
            <Col xl={3} md={4}>
              <LabelCustom text="วันที่เริ่มสัญญา" subtext={'(ถ้ามี)'} />
              <Controller
                name={'contractStartDate'}
                control={control}
                render={({ field: { onChange, value = '' } }) => (
                  <DatepickerCustom
                    value={value}
                    onChange={([date]) => {
                      let _date = date ? moment(date).format('YYYY-MM-DD') : ''
                      onChange(_date)
                    }}
                  />
                )}
              />
            </Col>
            <Col xl={3} md={4}>
              <LabelCustom text="วันที่สิ้นสุดสัญญา" subtext={'(ถ้ามี)'} />
              <Controller
                name={'contractDate'}
                control={control}
                render={({ field: { value = '', onChange } }) => (
                  <DatepickerCustom
                    value={value}
                    onChange={([date]) => {
                      onChange(date ? moment(date).format('YYYY-MM-DD') : '')
                    }}
                  />
                )}
              />
            </Col>
          </Row>
          <Row className="mt-3" style={{ rowGap: '15px' }}>
            <Col xl={2} md={6}>
              <LabelCustom text="คำนำหน้า" />
              <Controller
                name={'title_th'}
                control={control}
                render={({ field: { value = '' } }) => (
                  <Autocomplete
                    options={empsTitleTH}
                    value={value}
                    onChange={(d) => {
                      setValue('title_th', d)

                      const titleENNew = empsTitleEng.find(
                        (dt) => dt.id === d?.id
                      )
                      setValue('sex', { label: d.sex, value: d.sex })
                      setValue('title_en', titleENNew)
                      setError('title_th', d)
                      setError('title_en', titleENNew)
                    }}
                  />
                )}
              />
              {errors.title_th?.message && (
                <label className="small text-danger">
                  {errors.title_th.message}
                </label>
              )}
            </Col>
            <Col xl={4} md={6}>
              <LabelCustom text="ชื่อ" />
              <Controller
                name={'name_th'}
                control={control}
                render={({ field: { onChange, value = '' } }) => (
                  <Form.Control
                    value={value}
                    onChange={onChange}
                    // onKeyDown={handleKeyDownTH}
                  />
                )}
              />
              {errors.name_th?.message && (
                <label className="small text-danger">
                  {errors.name_th.message}
                </label>
              )}
            </Col>
            <Col xl={4} md={6}>
              <LabelCustom text="นามสกุล" />
              <Controller
                name={'surname_th'}
                control={control}
                render={({ field: { onChange, value = '' } }) => (
                  <Form.Control
                    value={value}
                    onChange={onChange}
                    maxLength={250}

                    // onKeyDown={handleKeyDownTH}
                  />
                )}
              />
              {errors.surname_th?.message && (
                <label className="small text-danger">
                  {errors.surname_th.message}
                </label>
              )}
            </Col>
            <Col xl={2} md={6}>
              <LabelCustom text="ชื่อเล่น" />
              <Controller
                name={'nickname_th'}
                control={control}
                render={({ field: { onChange, value = '' } }) => (
                  <Form.Control
                    value={value}
                    onChange={onChange}
                    maxLength={250}
                    // onKeyDown={handleKeyDownTH}
                  />
                )}
              />
              {errors.nickname_th?.message && (
                <label className="small text-danger">
                  {errors.nickname_th.message}
                </label>
              )}
            </Col>
            <Col xl={2} md={6}>
              <LabelCustom text="Prefix" />
              <Controller
                name={'title_en'}
                control={control}
                render={({ field: { value = '' } }) => (
                  <Autocomplete
                    options={empsTitleEng}
                    value={value}
                    onChange={(d) => {
                      setValue('title_en', d)
                      const titleENNew = empsTitleTH.find(
                        (dt) => dt.id === d?.id
                      )
                      setValue('title_th', titleENNew)
                      setValue('sex', { label: d.sex, value: d.sex })
                      setError('title_th', titleENNew)
                      setError('title_en', d)
                    }}
                  />
                )}
              />
              {errors.title_en?.message && (
                <label className="small text-danger">
                  {errors.title_en.message}
                </label>
              )}
            </Col>
            <Col xl={4} md={6}>
              <LabelCustom text="First Name" />
              <Controller
                name={'name_en'}
                control={control}
                render={({ field: { onChange, value = '' } }) => (
                  <Form.Control
                    value={value}
                    onChange={onChange}
                    maxLength={250}
                    pattern="^[A-Za-z\s\-\.\(\)]+$"
                    // onKeyDown={handleKeyDownENnum}
                  />
                )}
              />
              {errors.name_en?.message && (
                <label className="small text-danger">
                  {errors.name_en.message}
                </label>
              )}
            </Col>
            <Col xl={4} md={6}>
              <LabelCustom text="Last Name" />
              <Controller
                name={'surname_en'}
                control={control}
                render={({ field: { onChange, value = '' } }) => (
                  <Form.Control
                    value={value}
                    onChange={onChange}
                    maxLength={250}
                    pattern="^[A-Za-z\s\-\.\(\)]+$"

                    // onKeyDown={handleKeyDownENnum}
                  />
                )}
              />
              {errors.surname_en?.message && (
                <label className="small text-danger">
                  {errors.surname_en.message}
                </label>
              )}
            </Col>
            <Col xl={2} md={6}>
              <LabelCustom text="Nickname " />
              <Controller
                name={'nickname_en'}
                control={control}
                render={({ field: { onChange, value = '' } }) => (
                  <Form.Control
                    pattern="^[A-Za-z\s\-\.\(\)]+$"
                    value={value}
                    onChange={onChange}
                    // onKeyDown={handleKeyDownEN}
                  />
                )}
              />
              {errors.nickname_en?.message && (
                <label className="small text-danger">
                  {errors.nickname_en.message}
                </label>
              )}
            </Col>
            <Col xl={3} md={6}>
              <LabelCustom text="สายงาน" />
              <Controller
                name={'divisions'}
                control={control}
                render={({ field: { value = {} } }) => (
                  <Autocomplete
                    value={value}
                    options={divisions}
                    onChange={(res) => {
                      setError('divisions', res)
                      setValue('divisions', res)

                      setValue('department', {})
                      setValue('team', {})
                      setValue('position', {})
                      setValue('level_id', '')
                      setValue('faction', {})
                      setBdCheckPayment({
                        ...bdCheckPayment,
                        levelId: null
                      })
                      setValue('paymentGroup', null)
                      setDivisionId(res.value)
                      setFactionId(0)
                      setDepartmentId(0)
                      setTeamId(0)
                    }}
                  />
                )}
              />
              {errors.divisions?.message && (
                <label className="small text-danger">
                  {errors.divisions.message}
                </label>
              )}
            </Col>
            <Col xl={3} md={6}>
              <LabelCustom text="ฝ่าย" />
              <Controller
                name={'faction'}
                control={control}
                render={({ field: { value = {}, onChange } }) => (
                  <Autocomplete
                    disabled={divisionId > 0 ? false : true}
                    value={value}
                    options={factions}
                    onChange={(res) => {
                      onChange(res)

                      setValue('department', {})
                      setValue('team', {})
                      setValue('position', {})
                      setValue('level_id', '')
                      setBdCheckPayment({
                        ...bdCheckPayment,
                        levelId: null
                      })
                      setValue('paymentGroup', null)
                      setFactionId(res.value)
                      setDepartmentId(0)
                      setTeamId(0)
                    }}
                  />
                )}
              />
              {errors.faction?.message && (
                <label className="small text-danger">
                  {errors.faction.message}
                </label>
              )}
            </Col>
            <Col xl={3} md={6}>
              <LabelCustom text="แผนก " />
              <Controller
                name={'department'}
                control={control}
                render={({ field: { value = {} } }) => (
                  <Autocomplete
                    value={value}
                    disabled={factionId > 0 ? false : true}
                    options={department}
                    onChange={(res) => {
                      setDepartmentId(res.value)
                      setError('department', res)

                      setValue('department', res)
                      setValue('team', {})
                      setValue('position', {})
                      setValue('level_id', '')
                      setBdCheckPayment({
                        ...bdCheckPayment,
                        levelId: null
                      })
                      setValue('paymentGroup', null)
                      setTeamId(0)
                    }}
                  />
                )}
              />
              {errors.department?.message && (
                <label className="small text-danger">
                  {errors.department.message}
                </label>
              )}
            </Col>
            <Col xl={3} md={6}>
              <LabelCustom text="ทีม" />
              <Controller
                name={'team'}
                control={control}
                render={({ field: { value = {} } }) => (
                  <Autocomplete
                    value={value}
                    disabled={departmentId > 0 ? false : true}
                    options={teams}
                    onChange={(res) => {
                      setTeamId(res.value)
                      setValue('team', res)
                      setError('team', res)

                      setValue('position', {})
                      setValue('level_id', '')
                      setBdCheckPayment({
                        ...bdCheckPayment,
                        levelId: null
                      })
                      setValue('paymentGroup', null)
                    }}
                  />
                )}
              />
              {errors.team?.message && (
                <label className="small text-danger">
                  {errors.team.message}
                </label>
              )}
            </Col>
            <Col xl={3} md={6}>
              <LabelCustom text="ตำแหน่ง " />
              <Controller
                name={'position'}
                control={control}
                render={({ field: { value = {} } }) => (
                  <Autocomplete
                    value={value}
                    disabled={teamId > 0 ? false : true}
                    options={positions}
                    onChange={(res) => {
                      setValue('position', res)
                      setError('position', res)
                      setValue('level_id', res.level_id)
                      setError('level_id', res.level_id)
                      setBdCheckPayment({
                        ...bdCheckPayment,
                        levelId: res.level_id
                      })
                      getEmpChecksPaymentGroup({
                        ...bdCheckPayment,
                        levelId: res.level_id
                      })
                    }}
                  />
                )}
              />
              {errors.position?.message && (
                <label className="small text-danger">
                  {errors.position.message}
                </label>
              )}
            </Col>
            <Col xl={3} md={6}>
              <LabelCustom text="Level" />
              <Controller
                name={'level_id'}
                control={control}
                render={({ field: { onChange, value = '' } }) => (
                  <Form.Control readOnly value={value} onChange={onChange} />
                )}
              />
              {errors.level_id?.message && (
                <label className="small text-danger">
                  {errors.level_id.message}
                </label>
              )}
            </Col>
            <Col xl={3} md={6}>
              <LabelCustom text="Lark Level ID" subtext={'(ถ้ามี)'} />
              <Controller
                name={'orgLevelId'}
                control={control}
                render={({ field: { onChange, value = '' } }) => (
                  <Autocomplete
                    isClearable={true}
                    options={orgLevelIdOption}
                    value={value}
                    onChange={onChange}
                  />
                )}
              />
              {errors.lark_level_id?.message && (
                <label className="small text-danger">
                  {errors.level_id.message}
                </label>
              )}
            </Col>
            <Col xl={3} md={6}>
              <LabelCustom text="ผู้บังคับบัญชา" />

              <Controller
                name={'reportby'}
                control={control}
                render={({ field: { onChange, value = '' } }) => (
                  <Autocomplete
                    options={reportby}
                    value={value}
                    onChange={onChange}
                    onInputChange={(data) => {
                      setKeyReportTo(data)
                    }}
                  />
                )}
              />
              {errors.reportby?.message && (
                <label className="small text-danger">
                  {errors.reportby.message}
                </label>
              )}
            </Col>
            <Col xl={3}>
              <LabelCustom text="Supervisor" subtext={'(ถ้ามี)'} />
              <Controller
                name={'supervisor'}
                control={control}
                render={({ field: { onChange, value = null } }) => (
                  <Autocomplete
                    isClearable={true}
                    options={supervisor}
                    value={value}
                    onChange={onChange}
                    onInputChange={(data) => {
                      setKeySupervisor(data)
                    }}
                  />
                )}
              />
              {errors.supervisor?.message && (
                <label className="small text-danger">
                  {errors.supervisor.message}
                </label>
              )}
            </Col>
            <Col xl={3}>
              <LabelCustom text="เบอร์ภายใน" subtext={'(ถ้ามี)'} />
              <Controller
                name={'in_mobile'}
                control={control}
                render={({ field: { onChange, value = '' } }) => (
                  <Form.Control
                    maxLength={5}
                    value={value}
                    onChange={onChange}
                    onKeyDown={handleKeyDownNum}
                  />
                )}
              />
            </Col>
            <Col xl={3}>
              <LabelCustom text="เบอร์มือถือออฟฟิศ" subtext={'(ถ้ามี)'} />
              <Controller
                name={'in_mobile_offic'}
                control={control}
                render={({ field: { onChange, value = '' } }) => (
                  <Form.Control
                    value={value}
                    maxLength={15}
                    onChange={onChange}
                    onKeyDown={handleKeyDownNum}
                  />
                )}
              />
            </Col>
            <Col xl={3} md={6}>
              <LabelCustom text="ประเภทการจ่ายเงิน " />
              <Controller
                name={'payment'}
                control={control}
                render={({ field: { onChange, value = '' } }) => (
                  <Autocomplete
                    options={payments}
                    value={value}
                    onChange={(e) => {
                      setBdCheckPayment({
                        ...bdCheckPayment,
                        paymentId: e.value
                      })
                      getEmpChecksPaymentGroup({
                        ...bdCheckPayment,
                        paymentId: e.value
                      })
                      onChange(e)
                    }}
                  />
                )}
              />
              {errors.payment?.message && (
                <label className="small text-danger">
                  {errors.payment.message}
                </label>
              )}
            </Col>
            <Col xl={3} md={6}>
              <LabelCustom text="บัญชีธนาคาร" />
              <Controller
                name={'bank'}
                control={control}
                render={({ field: { onChange, value = '' } }) => (
                  <Autocomplete
                    options={banks}
                    value={value}
                    onChange={onChange}
                  />
                )}
              />
              {errors.bank?.message && (
                <label className="small text-danger">
                  {errors.bank.message}
                </label>
              )}
            </Col>
            <Col xl={3} md={6}>
              <LabelCustom text="เลขบัญชี" />
              <Controller
                name={'codeBank'}
                control={control}
                render={({ field: { onChange, value = '' } }) => (
                  <Form.Control
                    value={value}
                    maxLength={10}
                    pattern="[0-9]*"
                    onChange={onChange}
                    onKeyDown={handleKeyDownNum}
                  />
                )}
              />
              {errors.codeBank?.message && (
                <label className="small text-danger">
                  {errors.codeBank.message}
                </label>
              )}
            </Col>
            <Col xl={3} md={6}>
              <LabelCustom text="ตารางกะ " />
              <Controller
                name={'shift'}
                control={control}
                render={({ field: { onChange, value = '' } }) => (
                  <Autocomplete
                    options={shifts}
                    value={value}
                    onChange={onChange}
                  />
                )}
              />
              {errors.shift?.message && (
                <label className="small text-danger">
                  {errors.shift.message}
                </label>
              )}
            </Col>

            <Col xl={3}>
              <LabelCustom text="อีเมลบริษัท" subtext={'(ถ้ามี)'} />
              <Controller
                name={'email'}
                control={control}
                render={({ field: { onChange, value = '' } }) => (
                  <Form.Control
                    type="email"
                    value={value}
                    onChange={onChange}
                  />
                )}
              />
            </Col>

            <Col xl={3}>
              <LabelCustom text="Payment Group" />
              <Controller
                name={'paymentGroup'}
                control={control}
                render={({ field: { onChange, value = null } }) => (
                  <Autocomplete
                    options={paymentGroups}
                    value={value}
                    onChange={onChange}
                  />
                )}
              />
              {errors.paymentGroup?.message && (
                <label className="small text-danger">
                  {errors.paymentGroup.message}
                </label>
              )}
            </Col>
            <Col xl={3}>
              <LabelCustom text="Project" subtext={'(ถ้ามี)'} />
              <Controller
                name={'project'}
                control={control}
                render={({ field: { onChange, value = null } }) => (
                  <Autocomplete
                    isClearable={true}
                    options={projects}
                    value={value}
                    onChange={onChange}
                  />
                )}
              />
              {errors.project?.message && (
                <label className="small text-danger">
                  {errors.project.message}
                </label>
              )}
            </Col>
            <Col xl={3}>
              <LabelCustom text="Location" subtext={'(ถ้ามี)'} />
              <Controller
                name={'location'}
                control={control}
                render={({ field: { onChange, value = null } }) => (
                  <Autocomplete
                    isClearable={true}
                    options={airports}
                    value={value}
                    onChange={onChange}
                  />
                )}
              />
              {errors.location?.message && (
                <label className="small text-danger">
                  {errors.location.message}
                </label>
              )}
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </>
  )
}

export default Infomation
